module.exports = __webpack_public_path__ + "static/media/BIFI-BNB.29360cf7.png";